import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Thunk: fetch categories for report user
export const loadReportCategoryDataUser = createAsyncThunk(
  "reportUser/loadCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await agent.get(API.FORUM_REPORT_CATEGORY_USER); 
      return response.data?.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Thunk: save report against user
// export const saveForumReportUser = createAsyncThunk(
//   "reportUser/saveReport",
//   async (request, { rejectWithValue }) => {
//     try {
//       const response = await agent.post(API.SUBMIT_FORUM_REPORT_USER, request); 
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

export const saveForumReportUser = createAsyncThunk(
  "reportUser/saveReport",
  async (request, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.SUBMIT_FORUM_REPORT_USER, request);

      return {
        success: response.data?.success ?? true,
        message:
          response.data?.message ||
          response.data?.msg ||
          "Report submitted successfully",
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

const reportUserSlice = createSlice({
  name: "reportUser",
  initialState: {
    categories: [],
    loading: false,
    error: null,
    saveSuccess: false,
  },
  reducers: {
    resetSaveSuccess(state) {
      state.saveSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch categories
      .addCase(loadReportCategoryDataUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadReportCategoryDataUser.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(loadReportCategoryDataUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // save report
      .addCase(saveForumReportUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.saveSuccess = false;
      })
      .addCase(saveForumReportUser.fulfilled, (state) => {
        state.loading = false;
        state.saveSuccess = true;
      })
      .addCase(saveForumReportUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.saveSuccess = false;
      });
  },
});

export default reportUserSlice.reducer;
